import backend, {PAYMENT_API} from 'utils/backend/server/api_library';

const loadClientPaymentPlan = (clientRn) => {
  const url = `${PAYMENT_API}/payment/plan/client/${clientRn}`;
  return backend.get(url);
};

export default {
  loadClientPaymentPlan: loadClientPaymentPlan,
};
